<template>
    <div v-if="dictionary">
        <div ref="filterBarTop" class="vehicle-search__filter-bar vehicle-search__filter-bar--top" v-if="!hideFilter">
            <div class="vehicle-search__filter-bar-wrap">

                <!-- BRAND -->
                <MultiSelect appendTo="self" class="p-input-rounded" v-if="brandFacets != null && !preFilter?.Brand"
                    v-model="brands" :options="brandFacets" optionLabel="value.displayName" optionValue="value.id"
                    :placeholder="dictionary.VehicleSearchFilterBrandLabel" :showToggleAll="false"
                    :maxSelectedLabels="1" :selectedItemsLabel="this.$primevue.config.locale.selectionMessage" />

                <!-- MODEL -->
                <MultiSelect appendTo="self" class="p-input-rounded" v-if="modelFacets != null && !preFilter?.Model"
                    v-model="models" :options="modelFacets" optionLabel="value" optionValue="value"
                    :placeholder="dictionary.VehicleSearchFilterModelLabel" :showToggleAll="false"
                    :maxSelectedLabels="1" :selectedItemsLabel="this.$primevue.config.locale.selectionMessage" />

                <!-- TYPE/SEGMENT -->
                <MultiSelect appendTo="self" class="p-input-rounded"
                    v-if="segmentFacets != null && !preFilter?.Segments" v-model="segments" :options="segmentFacets"
                    optionLabel="value" optionValue="value" :placeholder="dictionary.VehicleSearchFilterTypeLabel"
                    :showToggleAll="false" :maxSelectedLabels="1"
                    :selectedItemsLabel="this.$primevue.config.locale.selectionMessage" />

                <!-- DRIVLINJE/BRÆNDSTOF/FUEL TYPE -->
                <MultiSelect appendTo="self" class="p-input-rounded"
                    v-if="fuelTypeFacets != null && !preFilter?.FuelType" v-model="fuelTypes" :options="fuelTypeFacets"
                    :optionLabel="VueHelpers.getFuelTypeDisplayName" optionValue="value"
                    :placeholder="dictionary.VehicleSearchFilterFuelTypeLabel" :showToggleAll="false"
                    :maxSelectedLabels="1" :selectedItemsLabel="this.$primevue.config.locale.selectionMessage">
                    <template #option="slotProps">
                        {{ VueHelpers.getFuelTypeDisplayName(slotProps.option.value) }}
                    </template>
                </MultiSelect>

                <!-- SEARCH/SØGNING -->
                <span class="p-input-icon-right" style="max-width:225px">
                    <i class="pi pi-search" @click="querySearch"></i>
                    <InputText class="p-input-rounded" v-model="query"
                        :placeholder="dictionary.VehicleSearchSearchFieldPlaceholder">
                    </InputText>
                </span>

                <Button @click="showSidebar = true" :label="filterButtonLabel" icon="pi pi-sliders-h" iconPos="right"
                    class="p-button-secondary p-button-sm  vehicle-search__filter-panel-toggle"></Button>
            </div>
            <div class="vehicle-search__filter-bar-wrap" v-if="hasLoadedInitials && numberOfFilters > 0">
                <VehicleSearchFilterPills :dictionary="dictionary" :brandFacets="brandFacets" :brands="brands"
                    :models="models" :segments="segments" :query="query" :equipments="equipments"
                    :leasingTypes="leasingTypes" :modelYears="modelYears"
                    :firstRegistrationYears="firstRegistrationYears" :fuelTypes="fuelTypes" :dealerCities="dealerCities"
                    :minPrice="minPrice" :maxPrice="maxPrice" :minClockedKilometers="minClockedKilometers"
                    :maxClockedKilometers="maxClockedKilometers" :minRange="minRange" :maxRange="maxRange"
                    :minBatteryCapacity="minBatteryCapacity" :maxBatteryCapacity="maxBatteryCapacity"
                    :minElectricConsumption="minElectricConsumption" :maxElectricConsumption="maxElectricConsumption"
                    @filterPillDismiss="handleFilterPillDismiss">
                </VehicleSearchFilterPills>
                <Button @click="resetFilter" class="p-button-secondary p-button-sm p-button-text">{{
                    dictionary.VehicleSearchFilterReset }}</Button>
            </div>

        </div>

        <div class="vehicle-search__filter-bar vehicle-search__filter-bar--bottom" v-if="!hideFilter">
            <div class="vehicle-search__filter-bar-wrap">
                <span class="p-input-icon-right">
                    <i class="pi pi-search" @click="querySearch"></i>
                    <InputText class="p-inputtext-lg p-input-rounded" v-model="query"
                        :placeholder="dictionary.VehicleSearchSearchFieldPlaceholder"></InputText>
                </span>
                <div class="vehicle-search__filter-panel-toggle-wrap">
                    <Button @click="showSidebar = true" :aria-label="dictionary.VehicleSearchFilterShowSidebarLabel"
                        icon="pi pi-sliders-h"
                        class="p-button-rounded p-button-outlined vehicle-search__filter-panel-toggle"></Button>
                    <div v-if="numberOfFilters > 0" class="vehicle-search__filter-panel-toggle-count"><span>{{
                        numberOfFilters }}</span></div>
                </div>
            </div>
        </div>

        <Sidebar v-if="!hideFilter" v-model:visible="showSidebar" :blockScroll="true" position="right"
            class="p-sidebar-md vehicle-search__filter-panel">
            <template #header="slotProps">
                <p>{{ dictionary.VehicleSearchFilterLabel }}</p>
                <Button class="p-button-secondary p-button-md p-button-text" @click="resetFilter">{{
                    dictionary.VehicleSearchFilterReset }}</Button>
            </template>
            <div class="vehicle-search__filter-panel-pills" v-if="hasLoadedInitials && numberOfFilters > 0">
                <p>{{ dictionary.VehicleSearchFilterSelectedFiltersLabel }}</p>
                <VehicleSearchFilterPills :dictionary="dictionary" :brandFacets="brandFacets" :brands="brands"
                    :models="models" :segments="segments" :query="query" :equipments="equipments"
                    :leasingTypes="leasingTypes" :modelYears="modelYears"
                    :firstRegistrationYears="firstRegistrationYears" :fuelTypes="fuelTypes" :dealerCities="dealerCities"
                    :minPrice="minPrice" :maxPrice="maxPrice" :minClockedKilometers="minClockedKilometers"
                    :maxClockedKilometers="maxClockedKilometers" :minRange="minRange" :maxRange="maxRange"
                    :minBatteryCapacity="minBatteryCapacity" :maxBatteryCapacity="maxBatteryCapacity"
                    :minElectricConsumption="minElectricConsumption" :maxElectricConsumption="maxElectricConsumption"
                    @filterPillDismiss="handleFilterPillDismiss">
                </VehicleSearchFilterPills>
                <div class="vehicle-search__filter-panel-pills-button-wrap">
                    <Button @click="resetFilter" class="p-button-text">{{ dictionary.VehicleSearchFilterReset
                        }}</Button>
                </div>
            </div>
            <div>
                <span class="p-input-icon-right vehicle-search__filter-panel-search">
                    <i class="pi pi-search" @click="querySearch"></i>
                    <InputText class="p-inputtext-lg p-input-rounded" v-model="query"
                        :placeholder="dictionary.VehicleSearchSearchFieldPlaceholder"></InputText>
                </span>
                <div class="vehicle-search__filter-panel-range" v-if="priceFacets != null">
                    <div class="field">
                        <label for="filterPriceMin">{{ dictionary.VehicleSearchFilterPriceMinLabel }}</label>
                        <div class="p-inputgroup">
                            <InputNumber id="filterPriceMin" v-model="minPrice" locale="da-DK" :maxFractionDigits="0"
                                :min="0" :highlightOnFocus="true" />
                            <span class="p-inputgroup-addon">kr.</span>
                        </div>
                    </div>
                    <span>-</span>
                    <div class="field">
                        <label for="filterPriceMax">{{ dictionary.VehicleSearchFilterPriceMaxLabel }}</label>
                        <div class="p-inputgroup">
                            <InputNumber id="filterPriceMax" v-model="maxPrice" locale="da-DK" :maxFractionDigits="0"
                                :highlightOnFocus="true" />
                            <span class="p-inputgroup-addon">kr.</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BRANDS/MÆRKER -->
            <div>
                <div v-if="brandFacets != null && !preFilter?.Brand" class="vehicle-search__filter-panel-brands-wrap">

                    <label id="brandFilterLabel">{{ dictionary.VehicleSearchFilterBrandsLabel }}</label>
                    <SelectButton aria-labelledby="brandFilterLabel"
                        class="vehicle-search__filter-panel-brands vehicle-search__filter-panel-brands--own-brands"
                        v-model="brands"
                        :options="brandFacets.filter(x => ownBrands.some(y => y.fullBrandAlias.toLowerCase() == x.value.id.toLowerCase()))"
                        optionLabel="value.displayName" optionValue="value.id" :multiple="true">
                        <template #option="slotProps">
                            <div
                                class="vehicle-search__filter-panel-brand vehicle-search__filter-panel-brand--own-brand">
                                <img v-if="brandLogoUrls[Object.keys(brandLogoUrls).find(key => key.toLowerCase() === slotProps.option.value.id)]"
                                    :src="brandLogoUrls[slotProps.option.value.id]" loading="lazy" alt="" height="25"
                                    style="height:25px;max-width:47px" />
                                <span>{{ slotProps.option.value.displayName }}</span>
                            </div>
                        </template>
                    </SelectButton>
                    <SelectButton aria-labelledby="brandFilterLabel" class="vehicle-search__filter-panel-brands"
                        v-model="brands"
                        :options="brandFacets.filter(x => !ownBrands.some(y => y.fullBrandAlias.toLowerCase() == x.value.id.toLowerCase()))"
                        optionLabel="value.displayName" optionValue="value.id" :multiple="true">
                        <template #option="slotProps">
                            <div class="vehicle-search__filter-panel-brand">
                                <span>{{ slotProps.option.value.displayName }}</span>
                            </div>
                        </template>
                    </SelectButton>
                </div>
            </div>

            <Accordion :multiple="true">
                <!-- TYPE/SEGMENT -->
                <AccordionTab v-if="segmentFacets != null && !preFilter?.Segments"
                    :header="dictionary.VehicleSearchFilterTypeLabel">
                    <div>
                        <div class="field-checkbox" v-for="segment in segmentFacets" :key="segment.value">
                            <Checkbox name="segment" :inputId="`segment${segment.value}`" :value="segment.value"
                                v-model="segments" />
                            <label :for="`segment${segment.value}`">{{ segment.value }} ({{ segment.hits }})</label>
                        </div>
                    </div>
                </AccordionTab>

                <!-- MODEL -->
                <AccordionTab v-if="modelFacets != null && !preFilter?.Model"
                    :header="dictionary.VehicleSearchFilterModelLabel">
                    <div>
                        <div class="field-checkbox" v-for="model in modelFacets" :key="model.value">
                            <Checkbox name="model" :inputId="`model${model.value}`" :value="model.value"
                                v-model="models" />
                            <label :for="`model${model.value}`">{{ model.value }} ({{ model.hits }})</label>
                        </div>
                    </div>
                </AccordionTab>

                <!-- UDSTYR/EQUIPMENT -->
                <AccordionTab v-if="equipmentFacets != null" :header="dictionary.VehicleSearchFilterEquipmentLabel">
                    <div>
                        <div class="field-checkbox" v-for="equipment in equipmentFacets" :key="equipment.value">
                            <Checkbox name="equipment" :inputId="equipment.value" :value="equipment.value"
                                v-model="equipments" />
                            <label :for="equipment.value">{{ equipment.value }} ({{ equipment.hits }})</label>
                        </div>
                    </div>
                </AccordionTab>

                <!-- DRIVLINJE/BRÆNDSTOF/FUEL TYPE -->
                <AccordionTab v-if="fuelTypeFacets != null && !preFilter?.FuelType"
                    :header="dictionary.VehicleSearchFilterFuelTypeLabel">
                    <div>
                        <div class="field-checkbox" v-for="fuelType in fuelTypeFacets" :key="fuelType.value">
                            <Checkbox name="fuelType" :inputId="`fuel${fuelType.value}`" :value="fuelType.value"
                                v-model="fuelTypes" />
                            <label :for="`fuel${fuelType.value}`">{{ VueHelpers.getFuelTypeDisplayName(fuelType.value)
                            }} ({{
                                    fuelType.hits
                                }})</label>
                        </div>
                    </div>
                </AccordionTab>

                <!-- FORHANDLER BY/DEALER CITY -->
                <AccordionTab v-if="dealerCityFacets != null && !preFilter?.DealerCity"
                    :header="dictionary.VehicleSearchFilterCityLabel">
                    <div>
                        <div class="field-checkbox" v-for="dealerCity in dealerCityFacets" :key="dealerCity.value">
                            <Checkbox name="dealerCity" :inputId="`city${dealerCity.value}`" :value="dealerCity.value"
                                v-model="dealerCities" />
                            <label :for="`city${dealerCity.value}`">{{ dealerCity.value }} ({{ dealerCity.hits
                                }})</label>
                        </div>
                    </div>
                </AccordionTab>

                <!-- LEASING TYPE -->
                <AccordionTab v-if="leasingTypeFacets != null && !preFilter?.LeasingType"
                    :header="dictionary.VehicleSearchFilterLeasingLabel">
                    <div>
                        <div class="field-checkbox" v-for="leasingType in leasingTypeFacets" :key="leasingType.value">
                            <Checkbox name="leasingType" :inputId="`leasing${leasingType.value}`"
                                :value="leasingType.value" v-model="leasingTypes" />
                            <label :for="`leasing${leasingType.value}`">{{ leasingType.value }} ({{ leasingType.hits
                                }})</label>
                        </div>
                    </div>
                </AccordionTab>

                <!-- MODELÅR/MODEL YEAR -->
                <AccordionTab v-if="modelYearFacets != null && !preFilter?.ModelYear"
                    :header="dictionary.VehicleSearchFilterModelYearLabel">
                    <div>
                        <div class="field-checkbox" v-for="modelYear in modelYearFacets" :key="modelYear.value">
                            <Checkbox name="modelYear" :inputId="`year${modelYear.value}`"
                                :value="modelYear.value.toString()" v-model="modelYears" />
                            <label :for="`year${modelYear.value}`">{{ modelYear.value }} ({{ modelYear.hits }})</label>
                        </div>
                    </div>
                </AccordionTab>

                <!-- INDREGISTRERINGSÅR/FIRST REGISTRATION YEAR -->
                <AccordionTab v-if="firstRegistrationYearFacets != null && !preFilter?.FirstRegistrationYear"
                    :header="dictionary.VehicleSearchFilterFirstRegistrationYearLabel">
                    <div>
                        <div class="field-checkbox" v-for="firstRegistrationYear in firstRegistrationYearFacets"
                            :key="firstRegistrationYear.value">
                            <Checkbox name="firstRegistrationYear" :inputId="`regYear${firstRegistrationYear.value}`"
                                :value="firstRegistrationYear.value.toString()" v-model="firstRegistrationYears" />
                            <label :for="`regYear${firstRegistrationYear.value}`">{{ firstRegistrationYear.value }} ({{
                                firstRegistrationYear.hits }})</label>
                        </div>
                    </div>
                </AccordionTab>

                <!-- KILOMETERSTAND/CLOCKED KILOMETERS -->
                <AccordionTab v-if="clockedKilometersFacets != null"
                    :header="dictionary.VehicleSearchFilterClockedKilometersLabel">
                    <div class="vehicle-search__filter-panel-range">
                        <div class="field">
                            <label for="filterMinClockedKilometers">{{
                                dictionary.VehicleSearchFilterClockedKilometersMinLabel
                            }}</label>

                            <div class="p-inputgroup">
                                <InputNumber id="filterMinClockedKilometers" v-model="minClockedKilometers"
                                    locale="da-DK" :maxFractionDigits="0" :min="0" :highlightOnFocus="true" />
                                <span class="p-inputgroup-addon">km</span>
                            </div>
                        </div>
                        <span>-</span>
                        <div class="field">
                            <label for="filterMaxClockedKilometers">{{
                                dictionary.VehicleSearchFilterClockedKilometersMaxLabel
                            }}</label>

                            <div class="p-inputgroup">
                                <InputNumber id="filterMaxClockedKilometers" v-model="maxClockedKilometers"
                                    locale="da-DK" :maxFractionDigits="0" :highlightOnFocus="true" />
                                <span class="p-inputgroup-addon">km</span>
                            </div>
                        </div>


                    </div>
                </AccordionTab>

                <!-- RÆKKEVIDDE/RANGE -->
                <AccordionTab v-if="rangeFacets != null" :header="dictionary.VehicleFilterRangeLabel">
                    <div class="vehicle-search__filter-panel-range">
                        <div class="field">
                            <label for="filterMinRange">{{
                                dictionary.VehicleFilterRangeMinLabel
                            }}</label>

                            <div class="p-inputgroup">
                                <InputNumber id="filterMinRange" v-model="minRange" locale="da-DK"
                                    :maxFractionDigits="0" :min="0" :highlightOnFocus="true" />
                                <span class="p-inputgroup-addon">km</span>
                            </div>
                        </div>
                        <span>-</span>
                        <div class="field">
                            <label for="filterMaxRange">{{
                                dictionary.VehicleFilterRangeMaxLabel
                            }}</label>

                            <div class="p-inputgroup">
                                <InputNumber id="filterMaxRange" v-model="maxRange" locale="da-DK"
                                    :maxFractionDigits="0" :highlightOnFocus="true" />
                                <span class="p-inputgroup-addon">km</span>
                            </div>
                        </div>


                    </div>
                </AccordionTab>

                <!-- BATTERIKAPACITET/BATTERY CAPACITY -->
                <AccordionTab v-if="batteryCapacityFacets != null"
                    :header="dictionary.VehicleSearchFilterBatteryCapacityLabel">
                    <div class="vehicle-search__filter-panel-range">
                        <div class="field">
                            <label for="filterMinBatteryCapacity">{{
                                dictionary.VehicleSearchFilterBatteryCapacityMinLabel
                            }}</label>

                            <div class="p-inputgroup">
                                <InputNumber id="filterMinBatteryCapacity" v-model="minBatteryCapacity" locale="da-DK"
                                    :maxFractionDigits="0" :min="0" :highlightOnFocus="true" />
                                <span class="p-inputgroup-addon">kWh</span>
                            </div>
                        </div>
                        <span>-</span>
                        <div class="field">
                            <label for="filterMaxBatteryCapacity">{{
                                dictionary.VehicleSearchFilterBatteryCapacityMaxLabel
                            }}</label>

                            <div class="p-inputgroup">
                                <InputNumber id="filterMaxBatteryCapacity" v-model="maxBatteryCapacity" locale="da-DK"
                                    :maxFractionDigits="0" :highlightOnFocus="true" />
                                <span class="p-inputgroup-addon">kWh</span>
                            </div>
                        </div>
                    </div>
                </AccordionTab>

                <!-- ELEKTRISK FORBRUG/ELECTRIC CONSUMPTION -->
                <AccordionTab v-if="electricConsumptionFacets != null"
                    :header="dictionary.VehicleSearchFilterElectricConsumptionLabel">
                    <div class="vehicle-search__filter-panel-range">
                        <div class="field">
                            <label for="filterMinElectricConsumption">{{
                                dictionary.VehicleSearchFilterElectricConsumptionMinLabel
                            }}</label>

                            <div class="p-inputgroup">
                                <InputNumber id="filterMinElectricConsumption" v-model="minElectricConsumption"
                                    locale="da-DK" :maxFractionDigits="0" :min="0" :highlightOnFocus="true" />
                                <span class="p-inputgroup-addon">Wh/km</span>
                            </div>
                        </div>
                        <span>-</span>
                        <div class="field">
                            <label for="filterMaxElectricConsumption">{{
                                dictionary.VehicleSearchFilterElectricConsumptionMaxLabel
                            }}</label>

                            <div class="p-inputgroup">
                                <InputNumber id="filterMaxElectricConsumption" v-model="maxElectricConsumption"
                                    locale="da-DK" :maxFractionDigits="0" :highlightOnFocus="true" />
                                <span class="p-inputgroup-addon">Wh/km</span>
                            </div>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>
            <div class="vehicle-search__filter-panel-summary" @click="showSidebar = false"
                v-html="dictionary.VehicleSearchFilterSidebarSummaryLabel.replace('{totalResults}', totalResults)">
            </div>
        </Sidebar>
        <p class="vehicle-search__results-summary"
            v-html="dictionary.VehicleSearchResultsSummaryText.replace('{totalResults}', totalResults)"></p>
        <div class="vehicle-search__results-header">

            <p class="vehicle-search__results-summary"
                v-html="dictionary.VehicleSearchResultsSummaryText.replace('{totalResults}', totalResults)"></p>
            <div class="vehicle-search__results-header-layout">
                <Button @click="() => { layout = 'grid' }" :aria-label="dictionary.VehicleSearchGridViewLabel"
                    icon="pi pi-th-large" class="p-button-rounded"
                    :class="{ 'p-button-outlined': layout != 'grid' }"></Button>

                <Button @click="() => { layout = 'list' }" :aria-label="dictionary.VehicleSearchListViewLabel"
                    icon="pi pi-bars" class="p-button-rounded"
                    :class="{ 'p-button-outlined': layout != 'list' }"></Button>

                <Button v-if="favoritesPageUrl" @click="handleShowSemlerSwiper"
                    :arial-label="dictionary.VehicleSearchSwiperViewLabel"
                    class="p-button-rounded p-button-icon-only p-button-outlined">
                    <img alt="dropdown icon" src="/assets/images/semlerSwiper/Overview_Filter.svg" width="15"
                        height="15" />
                </Button>
            </div>
            <Dropdown v-model="sortBy" :options="sortOptions" optionLabel="name" optionValue="code"
                :placeholder="dictionary.VehicleSearchSortLabel">
            </Dropdown>
        </div>

        <DataView :value="vehicles" :rows="pageSize" :totalRecords="totalResults" :paginator="(totalResults > pageSize)"
            :lazy="true" :first="((page - 1) * pageSize)" @page="(e) => { page = parseInt(e.page) + 1; scrollToTop(); }"
            :layout="layout" class="vehicle-search__results">
            <template #list="slotProps">
                <VehicleCard :vehicle="slotProps.data" :vehicleNodeId="nodeId" />
            </template>
            <template #grid="slotProps">
                <VehicleCard :vehicle="slotProps.data" :vehicleNodeId="nodeId" />
            </template>
        </DataView>
        <Toast position="top-center" />
        <SemlerSwiper v-if="favoritesPageUrl && hasLoadedInitials" :visible="showSemlerSwiper" :vehicles="vehicles"
            :vehicleNodeId="nodeId" :appendVehicles="appendVehiclesToSemlerSwiper" @openFilter="showSidebar = true"
            :skipOnboarding="skipSemlerSwiperOnboarding" :isUserLoggedIn="isUserLoggedIn"
            :favoritesPageUrl="favoritesPageUrl" @loadMoreVehicles="getNextPage" @closeSwiper="() => {
                showSemlerSwiper = false;
                page = 1;
            }" />
    </div>
</template>
<script>

import { nextTick } from 'vue'
import { bindRoute } from "./mixins/bindroute.js";
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataViewLayoutOptions';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Sidebar from 'primevue/sidebar';
import Slider from 'primevue/slider';
import SelectButton from 'primevue/selectbutton';
import Checkbox from 'primevue/checkbox';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import VehicleCard from './components/vehicleCard';
import MultiSelect from 'primevue/multiselect';
import Toast from 'primevue/toast';
import SemlerSwiper from './components/semlerSwiper';
import VueHelpers from './vueHelpers.js';
import VehicleSearchFilterPills from './components/vehicleSearchFilterPills.vue';

var queryTimer;


const defaultSort = "popularity";

export default {
    name: "VehicleSearch",
    components: {
        DataView,
        InputText,
        InputNumber,
        Button,
        Dropdown,
        Sidebar,
        Slider,
        SelectButton,
        Checkbox,
        Accordion,
        AccordionTab,
        VehicleCard,
        MultiSelect,
        Toast,
        DataViewLayoutOptions,
        SemlerSwiper,
        VehicleSearchFilterPills
    },
    props: ['dictionary', 'nodeId', 'isUserLoggedIn', 'hideFilter', 'preFilter', 'favoritesPageUrl'],
    data() {
        return {
            vehicles: [],
            showSidebar: false,
            totalResults: null,
            hasBeenFiltered: false,
            pageSize: 48,
            culture: "da-DK",
            hasLoadedInitials: false,
            isResetting: false,
            sortOptions: [
                { name: 'Pris - Stigende', code: 'priceLow' },
                { name: 'Pris - Faldende', code: 'priceHigh' },
                { name: 'Mest populære', code: 'popularity' },
                { name: 'Seneste', code: 'latest' },
            ],
            brandLogoUrls: {},
            brandFacets: null,
            segmentFacets: null,
            priceFacets: null,
            clockedKilometersFacets: null,
            rangeFacets: null,
            batteryCapacityFacets: null,
            electricConsumptionFacets: null,
            modelFacets: null,
            fuelTypeFacets: null,
            dealerCityFacets: null,
            modelYearFacets: null,
            firstRegistrationYearFacets: null,
            leasingTypeFacets: null,
            equipmentFacets: null,
            isLoading: false,
            layout: 'grid',
            showSemlerSwiper: false,
            appendVehiclesToSemlerSwiper: true,
            skipSemlerSwiperOnboarding: false,
            ownBrands: [],
            VueHelpers: VueHelpers
        };
    },
    created() {
        this.culture = document.querySelector("html").getAttribute("lang");

        window.matchMedia("(min-width:667px)").addEventListener("change", e => {
            if (e.matches) {
                this.showSemlerSwiper = false;
            }
        });


    },
    mounted() {
        const vm = this;

        vm.$router.isReady().then(() => {
            vm.setFilterStatusOnParentElement(vm.numberOfFilters);
            vm.getInitials();

        }).catch(error => {
            console.log(error);
        });

        this.setTopPositionOnScroll();
        window.addEventListener('scroll', this.setTopPositionOnScroll);
    },
    mixins: [
        bindRoute({
            page: 1,
            query: null,
            segments: null,
            models: null,
            brands: null,
            dealerCities: null,
            fuelTypes: null,
            modelYears: null,
            firstRegistrationYears: null,
            leasingTypes: null,
            equipments: null,
            minPrice: null,
            maxPrice: null,
            minClockedKilometers: null,
            maxClockedKilometers: null,
            minRange: null,
            maxRange: null,
            minBatteryCapacity: null,
            maxBatteryCapacity: null,
            minElectricConsumption: null,
            maxElectricConsumption: null,
            sortBy: defaultSort,
        }),
    ],
    watch: {
        numberOfFilters: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.setFilterStatusOnParentElement(newVal);
                }
            }
        },
        page: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true);
            }
        },
        query: {
            handler(newVal, oldVal) {
                clearTimeout(queryTimer);
                queryTimer = setTimeout(() => {
                    this.handleFilterPropertyChange(oldVal, newVal);
                }, 750);
            }
        },
        segments: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        brands: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        models: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        sortBy: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        fuelTypes: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        dealerCities: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        modelYears: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        firstRegistrationYears: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        leasingTypes: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        equipments: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal,);
            }
        },
        minPrice: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        maxPrice: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal,);
            }
        },
        minClockedKilometers: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        maxClockedKilometers: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        minRange: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        maxRange: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        minBatteryCapacity: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        maxBatteryCapacity: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        minElectricConsumption: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        maxElectricConsumption: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.setTopPositionOnScroll);
    },
    methods: {
        handleFilterPillDismiss(filter) {
            this[filter.name] = filter.value;
        },
        setFilterStatusOnParentElement(numberOfFilters) {
            const parentComponentElement = this.$el.closest('.vehicle-search');
            if (numberOfFilters > 0) {
                parentComponentElement.classList.add('vehicle-search--filtered');

            } else {
                parentComponentElement.classList.remove('vehicle-search--filtered');
            }
        },
        handleShowSemlerSwiper() {
            window.dataLayer.push({
                'event': 'swiper_open'
            });

            this.showSemlerSwiper = true;
        },
        setTopPositionOnScroll() {
            const el = this.$refs.filterBarTop;
            if (!el) return;

            const isAtTop = window.scrollY <= 0;
            el.style.top = isAtTop ? '150px' : '85px';
        },
        triggerSemlerSwiper() {
            const vm = this;

            const mobile = window.matchMedia("(max-width:666px)");
            //Swiper should only be accessible on mobile
            if (mobile.matches) {
                //Check if there is an initial like stored, meaning that the visit to this page is in the "context" of Semler Swiper, so we should open Semler Swiper
                const initialSemlerSwiper = localStorage.getItem(VueHelpers.initSemlerSwiperKey);
                if (initialSemlerSwiper || new URLSearchParams(window.location.search).get(VueHelpers.initSemlerSwiperKey)) {
                    if (initialSemlerSwiper) {
                        vm.skipSemlerSwiperOnboarding = true;
                    }
                    vm.showSemlerSwiper = true;
                }
            }

        },
        querySearch() {
            if (this.query) {
                this.filterChanged(true, false);
            }
        },
        search(amountToSkip, pageSize) {
            const vm = this;
            vm.isLoading = true;
            vm.toggleSpinner(true);
            var object = {
                nodeId: vm.nodeId,
                query: vm.query,
                sortBy: vm.sortBy,
                skip: amountToSkip,
                pageSize: pageSize,
                culture: vm.culture,
                brands: vm.brands?.length ? vm.brands : null,
                models: vm.models?.length ? vm.models : null,
                segments: vm.segments?.length ? vm?.segments : null,
                minPrice: vm.minPrice != null && vm.minPrice != 0 ? vm.minPrice : null,
                maxPrice: vm.maxPrice != null ? vm.maxPrice : null,
                minClockedKilometers: vm.minClockedKilometers != null && vm.minClockedKilometers != 0 ? vm.minClockedKilometers : null,
                maxClockedKilometers: vm.maxClockedKilometers != null ? vm.maxClockedKilometers : null,
                minRange: vm.minRange != null && vm.minRange != 0 ? vm.minRange : null,
                maxRange: vm.maxRange != null ? vm.maxRange : null,
                minBatteryCapacity: vm.minBatteryCapacity != null && vm.minBatteryCapacity != 0 ? vm.minBatteryCapacity : null,
                maxBatteryCapacity: vm.maxBatteryCapacity != null ? vm.maxBatteryCapacity : null,
                minElectricConsumption: vm.minElectricConsumption != null && vm.minElectricConsumption != 0 ? vm.minElectricConsumption : null,
                maxElectricConsumption: vm.maxElectricConsumption != null ? vm.maxElectricConsumption : null,
                fuelTypes: vm.fuelTypes?.length ? vm.fuelTypes : null,
                dealerCities: vm.dealerCities?.length ? vm.dealerCities : null,
                modelYears: vm.modelYears?.length ? vm.modelYears : null,
                firstRegistrationYears: vm.firstRegistrationYears ? vm.firstRegistrationYears : null,
                leasingTypes: vm.leasingTypes?.length ? vm.leasingTypes : null,
                equipments: vm.equipments?.length ? vm.equipments : null,
                searchLocation: 'Vehicles Page'
            };


            if (vm.preFilter?.Brand) {
                object.brands = vm.preFilter.Brand;
            }
            if (vm.preFilter?.Model) {
                object.models = vm.preFilter.Model;
            }
            if (vm.preFilter?.FuelType) {
                object.fuelTypes = vm.preFilter.FuelType;
            }
            if (vm.preFilter?.Segments) {
                object.segments = vm.preFilter?.Segments;
            }
            if (vm.preFilter?.DealerCity) {
                object.dealerCities = vm.preFilter?.DealerCity;
            }
            if (vm.preFilter?.ModelYear) {
                object.modelYears = vm.preFilter?.ModelYear;
            }
            if (vm.preFilter?.FirstRegistrationYear) {
                object.firstRegistrationYears = vm.preFilter?.FirstRegistrationYear;
            }
            if (vm.preFilter?.LeasingType) {
                object.leasingTypes = vm.preFilter?.LeasingType;
            }

            for (const [key, value] of Object.entries(object)) {
                if (value == null) {
                    delete object[key];
                }
            }

            fetch('/umbraco/api/ProductSearchApi/Search?' + new URLSearchParams(object)).then((response) => response.json())
                .then((data) => {
                    vm.vehicles = data.results;
                    vm.totalResults = data.totalResults;
                    vm.brandLogoUrls = data.brandLogoUrls;
                    vm.priceFacets = data.priceFacets.available;
                    vm.clockedKilometersFacets = data.clockedKilometersFacets.available;
                    vm.rangeFacets = data.rangeFacets.available;
                    vm.batteryCapacityFacets = data.batteryCapacityFacets.available,
                        vm.electricConsumptionFacets = data.electricConsumptionFacets.available,
                        vm.fuelTypeFacets = data.fuelTypeFacets.available;
                    vm.equipmentFacets = data.equipmentFacets.available;
                    vm.leasingTypeFacets = data.leasingTypeFacets.available?.filter(x => x.value != null && x.value != "");
                    vm.ownBrands = data.ownBrands;

                    //Order brands by the brands sorting order then alphabetically
                    var brandFacets = data.brandFacets.available;
                    const brandsSortingObject = vm.VueHelpers.brandsSortingObject.reduce((obj, item, index) => {
                        return {
                            ...obj,
                            [item]: index,
                        };
                    }, {});
                    vm.brandFacets = brandFacets.sort((a, b) => {
                        const indexA = !isNaN(brandsSortingObject[a.value.id]) ? brandsSortingObject[a.value.id] : Infinity;
                        const indexB = !isNaN(brandsSortingObject[b.value.id]) ? brandsSortingObject[b.value.id] : Infinity;

                        if (indexA !== indexB) {
                            return indexA - indexB;
                        }

                        return a.value.id.toLowerCase().localeCompare(b.value.id.toLowerCase());
                    });

                    //Ascending;
                    vm.segmentFacets = data.segmentFacets.available.sort((a, b) => {
                        const nameA = a.value.toUpperCase();
                        const nameB = b.value.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }

                        return 0;
                    });

                    //Ascending;
                    vm.modelFacets = data.modelFacets.available.filter(x => x.value).sort((a, b) => {
                        const nameA = a.value.toUpperCase();
                        const nameB = b.value.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }

                        return 0;
                    });



                    //Ascending;
                    vm.dealerCityFacets = data.dealerCityFacets.available.sort((a, b) => {
                        const nameA = a.value.toUpperCase();
                        const nameB = b.value.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }

                        return 0;
                    });

                    //Descending
                    vm.modelYearFacets = data.modelYearFacets.available.sort((a, b) => b.value - a.value);
                    vm.firstRegistrationYearFacets = data.firstRegistrationYearFacets.available.sort((a, b) => b.value - a.value);

                    nextTick(() => {

                        if (!vm.hasLoadedInitials) {
                            vm.triggerSemlerSwiper();
                        }

                        vm.hasLoadedInitials = true;
                        vm.isResetting = false;
                        vm.isLoading = false;
                        vm.toggleSpinner(false);
                    });

                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
            }
        },
        getInitials() {
            this.search((this.page - 1) * this.pageSize, this.pageSize);
        },
        handleFilterPropertyChange(oldVal, newVal, append = false) {
            let isChanged = false;
            if (Array.isArray(oldVal) && Array.isArray(newVal)) {
                isChanged = oldVal.sort().toString() !== newVal.sort().toString(); //We can do this because the arrays just contains simple values i.e. strings, numbers..
            } else {
                isChanged = oldVal !== newVal;
            }

            if (isChanged) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.appendVehiclesToSemlerSwiper = append;
                    this.filterChanged(append);
                }
            }
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.hasBeenFiltered = true;
            vm.query = null;
            vm.page = 1;
            vm.sortBy = vm.defaultSort;
            vm.segments = null;
            vm.minPrice = null;
            vm.maxPrice = null;
            vm.minClockedKilometers = null;
            vm.maxClockedKilometers = null;
            vm.minRange = null;
            vm.maxRange = null;
            vm.minBatteryCapacity = null;
            vm.maxBatteryCapacity = null;
            vm.minElectricConsumption = null;
            vm.maxElectricConsumption = null;
            vm.fuelTypes = null;
            vm.dealerCities = null;
            vm.modelYears = null;
            vm.firstRegistrationYears = null;
            vm.leasingTypes = null;
            vm.brands = null;
            vm.equipments = null;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.search(0, vm.pageSize);
                    vm.showSidebar = false;
                })
                .catch(err => { console.log(err); });
        },
        filterChanged(append = false) {
            this.hasBeenFiltered = true;
            this.isResetting = true;
            if (append == false) {
                this.page = 1;
            }
            this.search(this.pageSize * (this.page - 1), this.pageSize);
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
        scrollToTop() {
            const top = this.$el.offsetTop;
            window.scrollTo({
                top: top - 100,
                behavior: 'smooth',
            });
        }
    },
    computed: {
        hasMoreResults() {
            return (
                this.totalResults !== 0 &&
                this.vehicles.length < this.totalResults
            );
        },
        numberOfFilters() {
            let total = 0;
            total += this.query != null && this.query.length > 0
            total += this.segments?.length ?? 0;
            total += this.fuelTypes?.length ?? 0;
            total += this.dealerCities?.length ?? 0;
            total += this.modelYears?.length ?? 0;
            total += this.firstRegistrationYears?.length ?? 0;
            total += this.leasingTypes?.length ?? 0;
            total += this.brands?.length ?? 0;
            total += this.equipments?.length ?? 0;
            total += this.models?.length ?? 0;

            total += this.minPrice != null && this.minPrice > 0 ? 1 : 0;
            total += this.maxPrice != null ? 1 : 0;
            total += this.minClockedKilometers != null && this.minClockedKilometers > 0 != null ? 1 : 0;
            total += this.maxClockedKilometers != null ? 1 : 0;
            total += this.minRange != null && this.minRange > 0 ? 1 : 0;
            total += this.maxRange != null ? 1 : 0;
            total += this.minBatteryCapacity != null && this.minBatteryCapacity > 0 ? 1 : 0;
            total += this.maxBatteryCapacity != null ? 1 : 0;
            total += this.minElectricConsumption != null && this.minElectricConsumption > 0 ? 1 : 0;
            total += this.maxElectricConsumption != null ? 1 : 0;

            return total;
        },
        filterButtonLabel() {
            let label = "Flere filtre";
            let numberOfFilters = this.numberOfFilters;
            if (numberOfFilters > 0) {
                label += " (" + numberOfFilters + ")";
            }

            return label;
        }
    }
};
</script>
